









































































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import LeftNavigationComponent from "@/components/App/Modules/GMS/Workspace/Components/LeftNavigation.vue";
import TransactionList from "./Components/TransactionList.vue";
import PersonnelCost from "./Components/PersonnelCost.vue";
import Forecast from "./Components/Forecast.vue";
import DetailedListing from "./Components/DetailedListing.vue";
import Consolidation from "./Components/Consolidation.vue";
import ExpenditureStatement from "./Components/ExpenditureStatement.vue";
import DetailedExpense from './Components/DetailedExpenses.vue';
import SummaryReport from "./Components/SummaryReport.vue";
import { MigrationImport } from "@/entities";
import { AppConstants as _app } from "@/shared/app.constants";
import { Locales } from "@/i18n/locales";

const namespace: string = "migration";

@Component({
  components: {
    LeftNavigationComponent,
    TransactionList,
    PersonnelCost,
    Forecast,
    DetailedListing,
    Consolidation,
    ExpenditureStatement,
    DetailedExpense,
    SummaryReport,
  },
})
export default class MigrationFinanceWorkspaceComponent extends Vue {
  @State(namespace) migration!: MigrationImport;

  @Prop() schema!: any;
  @Prop() selectedKey!: string;
  @Prop() model!: any;
  @Prop() finPeriods!: any;
  @Prop() selectedIndex!: number;

  showSideBar = true;
  transactionValidations = [];
  personnelCostValidations = [];
  forecastValidations = [];
  expStatementValidations = [];
  actions = _app.actions;
  subjects = _app.subjects;
  finReportStatus = _app.finReportStatus;
  defaultLocale: string = localStorage.getItem("language") || Locales.EN;

  get finSchema() {
    if (this.schema && this.schema.properties) {
      delete this.schema.properties.finDocs;
      delete this.schema.properties.summary;

      return this.schema;
    }
  }

  get subSchema() {
    if (this.schema && this.schema.properties) {
      return this.schema.properties[this.selectedKey].properties;
    }
  }

  subMenuChanged(selectedMenu, key) {
    this.$emit("subMenuChanged", key);
  }

  sidebarToggle() {
    this.showSideBar = !this.showSideBar;
  }

  get forecastData() {
    let grantData: any = {};

    grantData.finReport = this.finPeriods.map(
      ({ description, startDate, endDate, dueDate }) => ({
        Description: description,
        StartDate: startDate,
        EndDate: endDate,
        DueDate: dueDate,
      })
    );

    let data = this.$services.monitor.transformForecastEntity(
      grantData,
      this.subSchema.forecastTemplate,
      false //isRAG
    );

    return data.finReport[this.selectedIndex];
  }

  get options() {
    return {
      baseURI: process.env.VUE_APP_API_Base_URL,
      currency: this.migration.Currency,
      disableAll: false,
      locale: this.defaultLocale
    };
  }

  setDirtyFlag(flag: boolean) {
    this.$emit("input", flag);
  }
}
